import gql from 'graphql-tag'
import { getConfiguredClient } from 'util/graphqlClient'

export const updateLocaleSetting = async (selectedLocale) => {
  const updateSettings = gql`
    mutation updateSettings($locale: String) {
      updateSettings(locale: $locale) {
        id
        settings {
          locale
        }
      }
    }
  `
  await getConfiguredClient().mutate({
      mutation: updateSettings,
      variables: {locale: selectedLocale}
    }
  )
}



// WEBPACK FOOTER //
// ./Linkgua/components/CustomerDetails/settings.js